<template>
    <div>
        <le-search-form @reset="handlerRest" @search="handlerSearch" >
            <le-input label="订单编号" v-model="pageParam.params.orderId" placeholder="请输入订单编号" />
            <le-date-range 
                label="订单时间" 
                :minDate.sync="pageParam.params.startTime" 
                :maxDate.sync="pageParam.params.endTime" 
                valueFormat="yyyy-MM-dd HH:mm:ss" 
                :defaultTime="['00:00:00','23:59:59']" />
        </le-search-form>
        <le-pagview ref="userBalanceUse" @setData="setTableData" :pageParam="pageParam" v-if="pageParam">
            <el-table :data="tabledata">
                <el-table-column label="订单编号" prop="typeText">
                    <template slot-scope="{ row }">
                        <span class="a-c-blue font-point" @click="handleToOrderInfo(row)">{{ row.orderId || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="充值消耗" prop="content">
                    <template slot-scope="{ row }">
                        <span>￥{{ util.numFormat(row.changeAmount) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="消耗后剩余" prop="orderId">
                    <template slot-scope="{ row }">
                        <span>￥{{ util.numFormat(row.afterBalance) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="订单类型" prop="activePower">
                    <template slot-scope="{ row }">
                        <span >{{ row.orderType | initDic(orderTypeDic) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="订单时间" prop="operatorUserPhone">
                    <template slot-scope="{ row }">
                        <span>{{ row.createTime || '-' }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </le-pagview>
    </div>
</template>

<script>
    import util from '@/utils/util.js'
    export default {
        data() {
            return {
                util: util,
                pageParam: {
                    url: this.$Config.apiUrl.getUserChargeBalanceConsumeList,
                    method: "post",
                    params: {
                        "endTime": "",
                        "orderId": "",
                        "startTime": "",
                        "userId": this.userId
                    },
                    freshCtrl: 1,
                },
                tabledata: [],
                orderTypeDic: []
            }
        },
        props:['userId','phone'],
        mounted () {
            this.$getDic('orderType').then(res=>{ this.orderTypeDic = res; })
        },
        methods:{
            handlerRest() {
                this.pageParam.params = {
                    "endTime": "",
                    "orderId": "",
                    "startTime": "",
                    "userId": this.userId
                };
                this.handlerSearch()
            },
            handlerSearch() {
                this.$refs.userBalanceUse.pageNum = 1
                this.pageParam.freshCtrl++;
            },
            setTableData (datas) {
                this.tabledata = datas.map(item=>{
                    return {
                        ...item,
                    }
                })
            },
            handleToOrderInfo (datas) {
                switch (datas.orderType){
					case 1:
						// 套餐订单
                        if (!this.$_has(72)) return this.$message.warning('暂无权限')
						this.$router.push({
                            path:'/order/package-order-info',
                            query: {
                                id: datas.orderId
                            }
                        })
						break;
					case 2:
						// 充电订单
                        if (!this.$_has(4)) return this.$message.warning('暂无权限')
						this.$router.push({
                            path: '/order/order-detail',
                            query: {
                                'orderId': datas.orderId
                            }
                        })
						break;
					case 4:
					case 5:
						// 充电柜订单
                        if (!this.$_has(101)) return this.$message.warning('暂无权限')
						this.$router.push({
                            path:'/order/chargeCabinet-order-info',
                            query: {
                                orderId: datas.orderId,
                                orderSn: datas.orderId
                            }
                        })
						break;
					default:
						break;
				}
            }
        }
    }
</script>

<style lang="scss" scoped>
   
</style>